import React, { useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { TextField } from '@material-ui/core';

interface EntryType {
  title: string;
}

export const ProviderInput = (props: {
  onChange: (name?: string) => void;
  team?: string;
  product?: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  id?: string;
  value?: string;
}) => {
  const catalogApi = useApi(catalogApiRef);
  const [entries, setEntries] = useState<EntryType[]>([]);
  const [initialValue, setInitialValue] = useState<EntryType | string>('');

  const { loading } = useAsync(async () => {
    if (props.product && props.team) {
      const entity = await catalogApi.getEntityByRef(
        `product:${props.product}`,
      );
      if (entity) {
        const items = Array.from(
          new Set(
            (entity.spec?.data as any).clusters?.map((it: any) => it.provider),
          ),
        ).map((it: any) => {
          return { title: it };
        });
        let initialEntry = items.find(e => e.title === props.value);
        if (!initialEntry && props.value) {
          props.onChange(undefined);
        } else if (!initialEntry && items.length == 1) {
          initialEntry = items[0];
          props.onChange(items[0].title);
        } else if (items.length == 0) {
          props.onChange(undefined);
        }
        setEntries(items);
        setInitialValue(initialEntry || '');
      } else {
        setEntries([]);
        setInitialValue('');
        props.onChange(undefined);
      }
    } else {
      setEntries([]);
      setInitialValue('');
      props.onChange(undefined);
    }
  }, [props.product, props.value, props.team]);

  const defaultProps = {
    options: entries,
    getOptionLabel: (option: EntryType) =>
      option?.title ? option.title.toUpperCase() : '',
  };

  return (
    <FormControl
      margin="dense"
      required={props.required}
      fullWidth={props.fullWidth}
    >
      <Autocomplete
        {...defaultProps}
        id={props.id}
        value={initialValue}
        loading={loading}
        freeSolo
        renderInput={params => (
          <TextField
            {...params}
            label={props.label ? props.label : 'Cloud Account'}
            margin="dense"
            helperText={
              props.helperText ? props.helperText : 'Select a Cloud Account'
            }
            FormHelperTextProps={{ margin: 'dense', style: { marginLeft: 0 } }}
            variant="outlined"
            required={props.required}
            InputProps={params.InputProps}
            error={props.error}
          />
        )}
        onChange={(_, newValue) =>
          props.onChange((newValue as EntryType)?.title)
        }
      />
    </FormControl>
  );
};
